app.controller("EditStudentSelectionController", [
    "$scope", "$uibModalInstance", "$interpolate", "$q", "StaticData", "toastr", "Selection", "Students", "params", "ConfirmModal",
    function ($scope, $uibModalInstance, $interpolate, $q, StaticData, toastr, Selection, Student, params, ConfirmModal) {
        $scope.sessions = params.sessions;
        $scope.selection = params.subjectSelection;
        var selection = params.subjectSelection;
        $scope.seminar = selection.seminar ? selection.seminar._id : null;
        $scope.lecture = selection.lecture ? selection.lecture._id : null;

        StaticData.getItemsByKey("days").then(function (days) {
            $scope.daysMap = _.keyBy(days, '_id');
        });

        function checkGroups() {
            return $q.all([
                Student.checkStudentGroupCollision($scope.selection.profile._id, $scope.lecture),
                Student.checkStudentGroupCollision($scope.selection.profile._id, $scope.seminar),
            ]).then(function (results) {
                return {
                    lecture: results[0],
                    seminar: results[1]
                }
            })
        }

        function getWarningHTML(warningData) {
            // var user = $scope.chosenStudent.user;
            $scope.collisions = warningData;
            var html = '<h3>სტუდენტისთვის <b>{{chosenStudent.user.firstName}} {{chosenStudent.user.lastName}}</b> აღმოჩენილია დამთხვევები სხვა საგნებზე</h3><br>';

            if (warningData.lecture.length) {
                html += '<h4>ლექციები:</h4>';
                for (var i in warningData.lecture) {
                    html += '<div>';
                    html += '<span style="color: #d72926;">{{daysMap[collisions.lecture[' + i + '].dayOfWeek].name}} {{collisions.lecture[' + i + '].startTime | date:\'HH:mm\' }}</span> ' +
                        'საგანზე "{{collisions.lecture[' + i + '].sessionGroup.subject.name}}", ჯგუფი - "{{collisions.lecture[' + i + '].sessionGroup.title}}"';
                    html += '</div>';
                }
            }

            if (warningData.seminar.length) {
                html += '<h4>სემინარები:</h4>';
                for (var i in warningData.seminar) {
                    html += '<div>';
                    html += '<span style="color: #d72926;">{{daysMap[collisions.seminar[' + i + '].dayOfWeek].name}} {{collisions.seminar[' + i + '].startTime | date:\'HH:mm\' }} </span>' +
                        'საგანზე "{{collisions.seminar[' + i + '].sessionGroup.subject.name}}", ჯგუფი - "{{collisions.seminar[' + i + '].sessionGroup.title}}"';
                    html += '</div>';
                }
            }
            return $interpolate(html)($scope);
        }

        $scope.update = function () {
            $scope.checking = true;
            checkGroups().then(function (result) {
                if (result.lecture.length || result.seminar.length) {
                    ConfirmModal.show({
                        title: "ყურადღება !",
                        html: getWarningHTML(result),
                        size: 'md'
                    }).result.then(function () {
                        $scope.checking = false;
                        return updateSelection();
                    }).catch(function () {
                        $scope.checking = false;
                    })
                } else {
                    $scope.checking = false;
                    return updateSelection();
                }
            });
        };

        function updateSelection() {
            $scope.checking = true;
            Selection.prove({
                selection: params.subjectSelection._id,
                seminar: $scope.seminar,
                lecture: $scope.lecture
            }).then(function () {
                var name = $scope.selection.profile.user.firstName + ' ' + $scope.selection.profile.user.lastName;
                toastr.success(name + ' რედაქტირებულია');
                $scope.checking = false;
                $uibModalInstance.close();
            });
        }

        $scope.close = function () {
            $uibModalInstance.dismiss();
        };
    }
]);